import firebase from 'firebase/app'
import 'firebase/storage'

var firebaseConfig = {
    apiKey: "AIzaSyB_ajpYghy8SO4sEELKCf_kiCTvu0-ftmA",
    authDomain: "abc1-ceaf0.firebaseapp.com",
    databaseURL: "https://abc1-ceaf0-default-rtdb.firebaseio.com",
    projectId: "abc1-ceaf0",
    storageBucket: "abc1-ceaf0.appspot.com",
    messagingSenderId: "286336602609",
    appId: "1:286336602609:web:2c67d7adeb06112278b450",
    measurementId: "G-Y16RLSZNE7"
};

  // Initialize Firebase
firebase.initializeApp(firebaseConfig);
//analytics is optional for this tutoral 
//firebase.analytics();

const storage = firebase.storage()

export  {
    storage, firebase as default
}




// WEBPACK FOOTER //
// ./src/firebase/firebase.js